import { __decorate } from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
let default_1 = class default_1 extends Vue {
    type;
    disableRight;
    get leftText() {
        if (this.type === 'detail') {
            return this.$t('return');
        }
        else {
            return this.$t('cancel');
        }
    }
    get rightText() {
        if (this.type === 'detail') {
            return this.$t('edit');
        }
        else {
            return this.$t('save');
        }
    }
    clickLeft() {
        this.$emit('leftClick');
    }
    clickRight() {
        if (!this.disableRight) {
            this.$emit('rightClick');
        }
    }
};
__decorate([
    Prop()
], default_1.prototype, "type", void 0);
__decorate([
    Prop()
], default_1.prototype, "disableRight", void 0);
default_1 = __decorate([
    Component({
        name: 'ButtonBox',
        components: {},
        i18n: {
            messages: {
                zh: {
                    return: '返回',
                    edit: '编辑',
                    cancel: '取消',
                    save: '保存',
                },
                en: {
                    return: 'Return',
                    edit: 'Edit',
                    cancel: 'Cancel',
                    save: 'Save',
                },
            },
        },
    })
], default_1);
export default default_1;
